import React, { useEffect, useMemo, useState } from "react";
import {
  Backdrop,
  Button,
  Chip,
  DetailCard,
  FormFieldSet,
  LogoLoader,
  LoopFieldsSet,
  Modal,
  showToast,
  Skeleton,
  useFormHandler,
} from "../../../../components";
import { v4 as uuidv4 } from "uuid";
import AddJobPostModal from "./Modals/AddJobPostModal";
// import { fetchCompaniesFromDB } from "../../../../redux/slices/accountDetails/accountDetailsApi";
import { debounce } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { addJobStart } from "../../../../redux/slices/leads/leadsSlice";
import { fetchProspectsByCompany } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { addCompanyApi } from "../../../../redux/slices/leads/leadsApi";
import { formatWords2 } from "../../../../utils/stringUtils";
import { fetchCompaniesFromDB } from "../../../../redux/slices/accountDetails/accountDetailsAPi";

const AddNewJobPost = () => {
  const [isAddJobPostModalOpen, setIsAddJobPostModalOpen] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [loading1, setLoading1] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const [modalData, setModalData] = useState(null);
  const [formLoading, setFormLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.leads?.loading);
  const initialFormData = {
    companyName: "",
    website: "",
    jobDescription: "",
    jobTitle: "",
    jobLocation: "",
    industry: "",
    postersDetails: [
      {
        id: uuidv4(),
        firstName: "",
        lastName: "",
        designation: "",
        email: "",
        phone: "",
        contactLocation: "",
      },
    ],
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, {
      companyName: { type: "text", required: true },
      website: { type: "url", required: true },
      jobDescription: { type: "text", required: true },
      jobTitle: { type: "select", required: true },
      postersDetails: [
        {
          firstName: { type: "text", required: true },
          lastName: { type: "text", required: true },
          designation: { type: "text", required: true },
          email: { type: "email", required: true },
          // phone: { type: "phone", required: true },
          contactLocation: { type: "select" },
        },
      ],
    });

  const addPostersDetails = () => {
    const newPoster = {
      id: uuidv4(),
      firstName: "",
      lastName: "",
      designation: "",
      email: "",
      phone: "",
      contactLocation: "",
    };

    setFormData({
      ...formData,
      postersDetails: [...formData.postersDetails, newPoster],
    });
  };

  const removePosterDetails = (posterId) => {
    if (formData.postersDetails.length > 1) {
      const updatedPosters = formData.postersDetails.filter(
        (poster) => poster.id !== posterId
      );
      setFormData({
        ...formData,
        postersDetails: updatedPosters,
      });
    }
  };
  const debouncedSearch = useMemo(
    () =>
      debounce(async (value) => {
        if (value.trim().length === 0) {
          setCompanies([]);
          return;
        }

        try {
          setLoading1(true);
          const res = await fetchCompaniesFromDB({
            coll: "Company",
            lim: 10,
            pg: 1,
            ret: "uiid name website industry addedBy jobIds",
            ref: "JobsWithProspect",
            incl: ["addedBy"],
            fil: {
              name: {
                type: "SEARCH",
                value: value,
              },
            },
          });

          setCompanies(res?.data?.data || []);
        } catch (error) {
          console.error("Error fetching companies:", error);
          setCompanies([]);
        } finally {
          setLoading1(false);
        }
      }, 300),
    []
  );
  useEffect(() => {
    debouncedSearch(formData?.companyName);
    const userIsTypingNewValue =
      selectedCompany && formData?.companyName !== selectedCompany.name;
    if (userIsTypingNewValue) {
      setSelectedCompany(null);
      setCompanyId(null);

      setFormData((prev) => ({
        ...prev,
        website: "",
        industry: "",
        postersDetails: [],
      }));
    }
    return () => {
      debouncedSearch.cancel();
    };
  }, [formData.companyName, debouncedSearch]);
  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      setFormLoading(true);
      const isValid = validateAllFields();
      if (!isValid) return;
      // if (!selectedCompany) {
      //   showToast("No company selected!", "error", 2000);
      //   return;
      // }
      if (formData.postersDetails.length > 5) {
        showToast("You can’t add more than 5 prospects!", "error", 2000);
        return;
      }
      const jobLocation =
        typeof formData?.jobLocation === "object" && formData?.jobLocation.value
          ? formData?.jobLocation.value
          : formData?.jobLocation;
      let [city, state] = (jobLocation || "").split("-");

      const jobFieldsPayload = {
        website: formData.website || "",
        description: formData.jobDescription || "",
        title: formData.jobTitle?.value ?? formData.jobTitle,
        location: { city, state },
        industry: formData.industry?.value ?? formData.industry,
        status: 2, //positive
      };

      // const prospectsPayload = formData.postersDetails.map((p) => {
      //   const location =
      //     typeof p.contactLocation === "object" && p.contactLocation.value
      //       ? p.contactLocation.value
      //       : p.contactLocation;
      //   const [pCity, pState] = (location || "").split("-");

      //   return {
      //     firstName: p.firstName || "",
      //     lastName: p.lastName || "",
      //     designation: p.designation || "",
      //     mobile: {
      //       code: p.phone?.code || "",
      //       number: p.phone?.number ? Number(p.phone.number) : null,
      //     },
      //     email: p.email || "",
      //     location: { city: pCity || "", state: pState || "" },
      //   };
      // });
      const prospectsPayload = formData.postersDetails.map((p) => {
        const location =
          typeof p?.contactLocation === "object" && p?.contactLocation.value
            ? p?.contactLocation?.value
            : p?.contactLocation;
        const [pCity, pState] = (location || "").split("-");

        const prospect = {
          firstName: p?.firstName || "",
          lastName: p?.lastName || "",
          designation: p?.designation || "",
          // email: p.email || "",
          email: {
            email: p?.email || "",
          },
          location: { city: pCity?.trim() || "", state: pState?.trim() || "" },
        };

        if (p?.phone?.number) {
          prospect.mobile = {
            code: p?.phone?.code || "",
            number: Number(p?.phone?.number),
          };
        }

        return prospect;
      });


      if (!user?.data?.uiid) throw new Error("User ID is missing");
      // if (!selectedCompany?.uiid) throw new Error("Please select a company");
      if (!selectedCompany?.uiid) {
        const payload = {
          coll: "Company",
          payload: {
            name: formData?.companyName.trim().toLowerCase(),
            addedBy: user?.data?.uiid,
            approval: {
              isEnabled: true,
            }
          },
        };
        const response = await addCompanyApi({ payload });
        if (response?.success) {
          setCompanyId(response?.data?.data?.uiid);
          const payload = {
            coll: "Job",
            postActions: ["AddToProspect"],
            payload: {
              ...jobFieldsPayload,
              addedBy: user?.data?.uiid,
              companyId: response?.data?.data?.uiid,
              Prospects: prospectsPayload,
              status: 2,
              modifiedBy: user?.data?.uiid,
              modifiedOn: new Date(),
              role: user?.data?.role?.type
            },
          };
          dispatch(
            addJobStart({
              payload,
              onSuccess: (res) => {
                const jobUiid = res?.data?.data?.uiid;
                showToast("Job added successfully!", "success");
                const snapshot = {
                  ...formData,
                  companyName: selectedCompany?.name || formData?.companyName,
                  website: selectedCompany?.website || formData?.website,
                  industry: selectedCompany?.industry || formData?.industry,
                  companyId: response?.data?.data?.uiid || null,
                };
                setModalData(snapshot);
                setFormData(initialFormData);
                setSelectedCompany(null);
                setCompanies([]);
                setJobId(jobUiid);
                setCompanies([]);
                setIsAddJobPostModalOpen(true);
              },
            })
          );
        }
      } else {
        const payload = {
          coll: "Job",
          postActions: ["AddToProspect"],
          payload: {
            ...jobFieldsPayload,
            addedBy: selectedCompany?.jobIds?.[selectedCompany.jobIds.length - 1]?.addedBy || selectedCompany?.addedBy,
            companyId: selectedCompany?.uiid,
            Prospects: prospectsPayload,
            status: 2,
            modifiedBy: user?.data?.uiid,
            modifiedOn: new Date(),
            role: user?.data?.role?.type
          },
        };
        dispatch(
          addJobStart({
            payload,
            onSuccess: (res) => {
              const jobUiid = res?.data?.data?.uiid;
              showToast("Job added successfully!", "success");
              const snapshot = {
                ...formData,
                companyName: selectedCompany?.name || formData?.companyName,
                website: selectedCompany?.website || formData?.website,
                industry: selectedCompany?.industry || formData?.industry,
                companyId: selectedCompany?.uiid || null,
              };
              setModalData(snapshot);
              setFormData(initialFormData);
              setSelectedCompany(null);
              setCompanies([]);
              setJobId(jobUiid);
              setCompanies([]);
              setIsAddJobPostModalOpen(true);
            },
          })
        );
      }
    } catch (err) {
      showToast(err?.message || "Failed to save job", "error");
    } finally {
      setFormLoading(false);
      setIsSubmitting(false);
    }
  };
  const handleCompanySelect = async (company) => {
    try {
      setFormLoading(true);
      setSelectedCompany(company);
      setCompanies([]);
      setCompanyId(company?.uiid);
      setFormData((prev) => ({
        ...prev,
        companyName: company?.name || "",
        website: company?.website || "",
        industry: company?.industry || "",
      }));

      const res = await fetchProspectsByCompany({
        coll: "Prospect",
        fil: { companyId: { type: "NONE", value: company?.uiid } },
        ret: "firstName lastName designation email mobile location",
        // lim: 100,
        lim: 5,
      });

      const prospects = res?.data?.data || [];
      const postersMapped = prospects.map((p) => ({
        id: uuidv4(),
        firstName: p?.firstName || "",
        lastName: p?.lastName || "",
        designation: p?.designation || "",
        email: p?.email?.email || p?.email || "",
        phone: {
          code: p?.mobile?.code || "",
          number: p?.mobile?.number || "",
        },
        // contactLocation: p.location
        //   ? `${p.location.city || ""}-${p.location.state || ""}`
        //   : "",
        contactLocation: p?.location
          ? [p?.location?.city, p?.location?.state].filter(Boolean).join("-")
          : ""
      }));

      setFormData((prev) => ({
        ...prev,
        postersDetails:
          postersMapped.length > 0 ? postersMapped : prev.postersDetails,
      }));
    } catch (err) {
      console.error("Error fetching prospects:", err);
      showToast("Failed to fetch prospects", "error");
    } finally {
      setFormLoading(false);
    }
  };

  if (formLoading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-white/40 backdrop-blur-sm z-50 rounded-lg">
        <LogoLoader />
      </div>
    );
  }
  return (
    <div className="p-4">
      <h5>Job Details</h5>

      <div className="grid lg:grid-cols-3 xl:grid-cols-4 md:grid-cols-3 gap-5">
        <FormFieldSet
          title="Company Name"
          placeholder="Company Name"
          value={formData.companyName}
          onChange={(value) => handleChange("companyName", value)}
          error={errors.companyName}
          shadow={true}
        />
        <FormFieldSet
          title="Website"
          placeholder="Website"
          value={formData.website}
          onChange={(value) => handleChange("website", value)}
          error={errors.website}
          shadow={true}
        />
        <FormFieldSet
          title="Job Description"
          placeholder="Job Description"
          value={formData.jobDescription}
          onChange={(value) => handleChange("jobDescription", value)}
          error={errors.jobDescription}
          shadow={true}
        />
        <FormFieldSet
          type="atsJobTitle"
          title="Job Title"
          placeholder="Application Engineer"
          value={formData.jobTitle}
          onChange={(value) => handleChange("jobTitle", value)}
          error={errors.jobTitle}
          showButton
          showSearch
          shadow={true}
        />

        {/* <div className="grid grid-cols-4 gap-5"> */}
        <FormFieldSet
          // type="citiesState"
          type="atscitiesState"
          title="Job Location"
          placeholder="Location, State"
          value={formData.jobLocation}
          onChange={(value) => handleChange("jobLocation", value)}
          error={errors.jobLocation}
          showSearch
          parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
          shadow={true}
        />
        {/* <FormFieldSet
            title="Select Industry"
            placeholder="Select Industry"
            value={formData.industry}
            onChange={(value) => handleChange("industry", value)}
            error={errors.industry}
          /> */}
        <FormFieldSet
          type="industry"
          title="Select Industry"
          placeholder="Select Industry"
          value={formData.industry}
          onChange={(value) => handleChange("industry", value)}
          error={errors.industry}
          options={[]}
          showButton
          showSearch
          shadow={true}
        />
        {/* </div> */}
      </div>

      <LoopFieldsSet
        title="Job Posters Details"
        data={formData.postersDetails}
        onAdd={addPostersDetails}
        onRemove={removePosterDetails}
        maxItems={5}
        gridCols="grid md:grid-cols-4 xl:grid-cols-[repeat(6,1fr)_40px]"
        addButtonTitle="Add More Contacts"
        renderFields={(poster, index) => (
          <>

            <FormFieldSet
              type="text"
              title="First Name"
              placeholder="Enter First Name"
              value={poster.firstName || ""}
              onChange={(value) =>
                handleChange(`postersDetails[${index}].firstName`, value)
              }
              error={errors.postersDetails?.[index]?.firstName}
              shadow={true}
            />
            <FormFieldSet
              type="text"
              title="Last Name"
              placeholder="Enter Last Name"
              value={poster.lastName || ""}
              onChange={(value) =>
                handleChange(`postersDetails[${index}].lastName`, value)
              }
              error={errors.postersDetails?.[index]?.lastName}
              shadow={true}
            />
            <FormFieldSet
              type="text"
              title="Designation"
              placeholder="Enter Designation"
              value={poster.designation || ""}
              onChange={(value) =>
                handleChange(`postersDetails[${index}].designation`, value)
              }
              error={errors.postersDetails?.[index]?.designation}
              shadow={true}
            />
            <FormFieldSet
              type="text"
              title="Email Id"
              placeholder="Enter Email Id"
              value={poster.email || ""}
              onChange={(value) =>
                handleChange(`postersDetails[${index}].email`, value)
              }
              error={errors.postersDetails?.[index]?.email}
              shadow={true}
            />
            {/* <FormFieldSet
              type="phoneNew"
              title="Phone"
              placeholder="Enter Phone"
              // values={[poster.phone]}
              // onChange={(value) =>
              //   handleChange(`postersDetails[${index}].phone`, value)
              // }
              values={[poster.phone || { code: "", number: "" }]} // ensure default object
              onChange={(value) =>
                handleChange(
                  `postersDetails[${index}].phone`,
                  value[0] || { code: "", number: "" }
                )
              }
              error={errors.postersDetails?.[index]?.phone}
              shadow={true}
            /> */}
            <FormFieldSet
              type="phone"
              title="Phone"
              placeholder="Enter Mobile Number"
              value={poster.phone?.number || ""}
              code={poster.phone?.code || ""}
              onChange={(fullValue, details) =>
                handleChange(`postersDetails[${index}].phone`, {
                  code: details.countryCode,
                  number: details.number,
                })
              }
              error={errors.postersDetails?.[index]?.phone}
            />
            <FormFieldSet
              // type="citiesState"
              type="atscitiesState"
              title="Contact Location"
              placeholder="Select Contact Location"
              options={[]}
              value={poster.contactLocation || ""}
              onChange={(value) =>
                handleChange(`postersDetails[${index}].contactLocation`, value)
              }
              error={errors.postersDetails?.[index]?.contactLocation}
              showSearch
              parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
              shadow={true}
            />
          </>
        )}
      />
      <div className="flex justify-end mt-10 ">
        <Button
          title={"Submit"}
          onClick={handleSubmit}
          disabled={isSubmitting || loading}
        />
      </div>
      <Modal
        title={"Add Job Post"}
        isOpen={isAddJobPostModalOpen}
        onClose={() => setIsAddJobPostModalOpen(false)}
        width="w-full"
      >
        <AddJobPostModal
          onClose={() => setIsAddJobPostModalOpen(false)}
          // data={initialFormData}
          // data={{
          //   ...formData,
          //   companyName: selectedCompany?.name || formData.companyName,
          //   website: selectedCompany?.website || formData.website,
          //   industry: selectedCompany?.industry || formData.industry,
          //   companyId: selectedCompany?.uiid || null,
          // }}
          data={modalData}
          jobId={jobId}
          companyId={companyId}
        />
      </Modal>

      {formData.companyName.length >= 2 && !selectedCompany ? (
        <div>
          <h6 className="my-6 underline underline-offset-5 decoration-2 decoration-primary-300">
            List of Companies
          </h6>
          {/* <div className="grid grid-cols-3 gap-x-14 gap-y-8 max-w-7xl">
            {Array.from({ length: 12 }, (_, i) => (
              <DetailCard
                title={
                  <div>
                    <h6 className="line-clamp-1">
                      MOHR Test and Measurement LLC
                    </h6>
                  </div>
                }
                headeRight={
                  <div className="mr-2">
                    <Button icon={"add"} type="icon" size="sm" />
                  </div>
                }
              >
                <div className="flex justify-between items-center">
                  <div>https://testinc.com</div>
                  <div>
                    <Chip
                      label="Civil Engineering"
                      color="invoiced"
                      className="!rounded-full"
                    />
                  </div>
                </div>
              </DetailCard>
            ))}
          </div> */}
          {loading1 ? (
            <Skeleton variant="paragraph" lines={3} />
          ) : (
            <div className="grid grid-cols-3 gap-x-14 gap-y-8 max-w-7xl">
              {companies.length > 0
                ? companies.map((company) => (
                  <DetailCard
                    key={company.uiid}
                    title={
                      <div>
                        <h6 className="line-clamp-1">{formatWords2(company.name)}</h6>
                      </div>
                    }
                    headeRight={
                      <div className="mr-2">
                        <Button
                          icon={"add"}
                          type="icon"
                          size="sm"
                          // onClick={() => {
                          //   setSelectedCompany(company);
                          //   setFormData({
                          //     ...formData,
                          //     companyName: company.name || "",
                          //     website: company.website || "",
                          //     industry: company.industry || "",
                          //   });
                          // }}
                          onClick={() => handleCompanySelect(company)}
                        />
                      </div>
                    }
                  >
                    <div className="flex justify-between items-center">
                      <div>{company.website || "-"}</div>
                      <div>
                        <Chip
                          label={formatWords2(company.industry || "-")}
                          color="invoiced"
                          className="!rounded-full"
                        />
                      </div>
                    </div>
                  </DetailCard>
                ))
                : !selectedCompany && <div>No companies found</div>}
            </div>
          )}
        </div>
      ) : (
        ""
      )}
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default AddNewJobPost;
